document.importNodeIE9 = (node, allChildren) =>
    switch node.nodeType
        when document.ELEMENT_NODE
            newNode = document.createElementNS(node.namespaceURI, node.nodeName)
            if node.attributes && node.attributes.length > 0
                for nodeAttribute in node.attributes
                    newNode.setAttribute(nodeAttribute.nodeName, node.getAttribute(nodeAttribute.nodeName))
            if allChildren && node.childNodes and node.childNodes.length > 0
                for nodeChildNode in node.childNodes
                    newNode.appendChild(document.importNodeIE9(nodeChildNode, allChildren))
            return newNode;
        when document.TEXT_NODE, document.CDATA_SECTION_NODE, document.COMMENT_NODE
          return document.createTextNode(node.nodeValue);
    return
